class ErrorCtrl {
	constructor($window, apiServ) {
		this.$window = $window;
		this.apiServ = apiServ;

		this.redirectToErrorPage();
	}

	redirectToErrorPage() {
		this.$window.location.href = this.apiServ.readUrl('error');
	}
}

ErrorCtrl.$inject = ['$window', 'apiServ'];

export default ErrorCtrl;